import React from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Section, Container } from 'components/shared';
import { isValidTitle } from 'utils/validateTitle';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';

import loadable from '@loadable/component';
const QuestionsAndAnswers = loadable(() =>
  import('components/components/organisms/QuestionsAndAnswers'),
);
const StyledHeading = styled.h1`
  margin-bottom: 0px;
  font-size: 1.625rem;
  @media ${breakpoints.lg} {
    font-size: 2.25rem;
  }
  @media ${breakpoints.xl} {
    margin-left: 0;
    font-size: 2.875rem;
  }
`;

const Copy = styled.div`
  letter-spacing: 0.14px;
  line-height: 1.625rem;
  @media ${breakpoints.md} {
    max-width: 55rem;
  }
`;

const hasContent = (value) => typeof value === 'string' && value.trim();

const FAQsContainer = ({ fields }) => {
  const faqsList = getFieldValue(fields, 'faqsList') || [];
  const filteredFaqsList = faqsList
    .map((faq = {}) => ({
      ...faq,
      questionAndAnswers: Array.isArray(faq.questionAndAnswers)
        ? faq.questionAndAnswers.filter(
            ({ question, answer } = {}) =>
              hasContent(question) && hasContent(answer),
          )
        : [],
    }))
    .filter(({ questionAndAnswers }) => questionAndAnswers.length > 0);

  if (!(filteredFaqsList && filteredFaqsList.length > 0)) {
    return null;
  }

  return (
    <>
      <Section id='timeline'>
        {filteredFaqsList &&
          filteredFaqsList.map((data, i) => {
            const title = data.title;
            const text = data.copy;
            const faqs = data.questionAndAnswers || [];
            return (
              <Container
                key={i}
                className={
                  i < filteredFaqsList.length - 1 ? 'mb-8 md:mb-12' : ''
                }
              >
                <div className='w-full h-full flex flex-col items-center text-center '>
                  {isValidTitle(title) && (
                    <StyledHeading className='mt-2 font-bold leading-tiny font-trade-gothic-20 mb-6 md:mb-10-mattamy text-4xl text-mattamy-blue text-center'>
                      {title}
                    </StyledHeading>
                  )}
                  {isValidTitle(text) && (
                    <Copy className='mt-0 md:mt-2 text-xl leading-7 font-graphie text-mattamy-blue text-center'>
                      {text}
                    </Copy>
                  )}
                </div>
                <QuestionsAndAnswers
                  faqs={faqs}
                  openOnLanding={data.openOnLanding}
                />
              </Container>
            );
          })}
      </Section>
    </>
  );
};

export default FAQsContainer;
